import {
  mapState,
  mapMutations
} from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import api from '../service/services'
import $ from 'jquery'
import swal from 'sweetalert2'

export default {
  data() {
    return {
      submitted: false,
      flag_cash: 0,
      fac_Refund: 0,
      payload: '',
      txn_id: '',
      info: {},
      isLoadingcash: '',
      walletChangeID: [{
        data: ''
      },
      {
        data: ''
      },
      {
        data: ''
      },
      {
        data: '-'
      },
      {
        data: ''
      },
      {
        data: ''
      },
      {
        data: ''
      },
      {
        data: '-'
      },
      {
        data: ''
      },
      {
        data: ''
      },
      {
        data: ''
      },
      {
        data: ''
      }
      ],
      numberID: '',
      ChangeID: '',
      checkonhand: '',
      status_partner: false,
      checkWebSocket: false
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState([
      'isLoading',
      'UUID',
      'lang',
      'IDWallet',
      'SaleID',
      'SaleType',
      'PaymentType',
      'accessToken',
      'AmountPayment',
      'reponseStatus',
      'sale_info',
      'printer_step',
      'sale_pay',
      'config',
      'sale_subs_slip'
    ]),
    ...mapMutations(['onMessageWs'])
  },
  methods: {
    back() {
      this.Soundclick()
      if (this.AmountPayment > 0) {
        $('#walletid').modal('show')
        this.$socket.sendObj({
          command: 'receive_close'
        })
      } else {
        clearTimeout(this.checkonhand)
        const obj = {
          ref_number: this.$store.state.ref_number,
          status: 'REJECTED'
        }
        const header = {
          headers: {
            'x-access-token': this.accessToken
            // "x-access-token": '942be569a799418c9b4249dc964e7930'
          }
        }
        api.getReceiveC9(
          obj,
          header,
          result => {
            this.$store.state.IDWallet = null
            console.log(result)
            // this.$router.push({ื
            //   name: 'Main'
            // })
            this.$router.go(-1)
            // this.$store.state.AmountPayment = 0
            // this.$store.state.sale_subs = []
            this.$socket.sendObj({
              command: 'receive_close'
            })
            this.$store.state.isLoading = true
          },
          error => {
            alert(JSON.stringify(error))
          }
        )
      }
    },
    websocket_onmessage() {
      this.$socket.onmessage = skResult => {
        this.$store.commit('onMessageWs', JSON.parse(skResult.data))
        this.check_cashrecive()
      }
    },
    check_cashrecive () {
      if (this.$store.state.AmountPayment >= this.$store.state.total) {
          this.Payment()
        // if(this.SaleID != 1){
        //   if(this.AmountPayment >= this.$store.state.total && this.checkWebSocket == false) {
        //     this.checkWebSocket = true
        //     this.$socket.sendObj({
        //       command: 'receive_close'
        //     })
        //     $('#walletid').modal('show')
        //     console.log("จ่ายเงินครบแล้ว")
        //   }
        // }
      }
    },
    ReceiveMoney() {
      try {
        this.$socket.sendObj({
          command: 'receive_open'
        })
        console.log(
          'สั่งรับเงิน = ' +
          JSON.stringify({
            command: 'receive_open'
          })
        )
        this.$store.state.isLoading = true
        this.checkonhand = setTimeout(() => {
          if (this.isLoading === true) {
            this.$socket.sendObj({
              command: 'receive_close'
            })
            this.$store.state.isLoading = false
            alert('ระบบรับเงินมีปัญหา กรุณาทำรายการใหม่')
            this.$router.go(-1)
          }
        }, 10000)
      } catch (e) {
        alert('ระบบรับเงินมีปัญหา กรุณาทำรายการใหม่')
        this.$store.state.IDWallet = null
        console.log(this.$store.state.IDWallet)
        // console.log("asda",e)
        // location.reload()
        this.back()
      }
    },
    BackReceiveMoney() {
      this.$socket.sendObj({
        command: 'receive_open'
      })
      console.log('สั่งรับเงิน = ' + JSON.stringify({ command: 'receive_open' }))
      this.$store.state.isLoading = true
      this.checkonhand = setTimeout(() => {
        if (this.isLoading === true) {
          this.$store.state.isLoading = false
          swal
            .fire({
              title: 'ระบบมีปัญหา?',
              text: 'กรุณาลองทำการการใหม่',
              type: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              // cancelButtonColor: '#d33',
              confirmButtonText: 'ตกลง',
              // cancelButtonText: 'No'
            })
            .then(result => {
              if (result.value) {
                $('#walletid').modal('show')
                this.$socket.sendObj({
                  command: 'receive_open'
                })
              }
            })
        }
      }, 10000)
    },
    openSale() {
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }
      console.log(header)
      console.log(sessionStorage.accessToken)
      api.openSale(
        header,
        result => {
          console.log(result)
          this.txn_id = result.txn_id
          this.$store.state.sale_info = result.info
        },
        error => {
          console.log(error)
        }
      )
    },
    refund() {
      // this.SaleID = 1
      this.Soundclick()
      $('#walletid').modal('hide')
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }

      if (this.SaleID == 1) {
        var mode = 'Deposit'
        var payment_type_text = 'cash'
        var type_text = 'Wallet'
        switch (this.lang) {
          case 0:
            payment_type_text = 'cash'
            type_text = 'Wallet'
            mode = 'Deposit'
            break
          case 1:
            payment_type_text = 'เงินสด'
            type_text = 'เติมเงิน Wallet'
            mode = 'เติมเงิน'
            break
          case 2:
            payment_type_text = '現金'
            type_text = 'Wallet'
            mode = '存款'
            break
        }
        this.$store.state.sale_subs = [{
          line: 1,
          item_id: '0',
          item_name: payment_type_text,
          qty: 1,
          price_id: 1,
          price_name: type_text,
          price: parseFloat(this.AmountPayment),
          unit: ''
        }]
      }

      if (this.$store.state.SaleID !== 5) {
        this.$store.state.ref_number = this.txn_id
        this.status_partner = false
      } else {
        this.status_partner = true
      }
      var numberPhone = this.$store.state.IDWallet.substring(1, this.$store.state.IDWallet.length)

      this.payload = {
        shift_uuid: this.$store.state.shift_uuid,
        ref_number: this.$store.state.ref_number,
        txn_id: this.txn_id,
        type: 'deposit_cash',
        partner: this.status_partner,
        member_phone: '+66' + numberPhone,
        amount: parseFloat(this.AmountPayment),
        payment_received: parseFloat(this.AmountPayment),
        payment_change: 0,
        flag_cash: 0,
        payment: {
          currency: 'THB',
          b1000: this.sale_pay.b1000,
          b500: this.sale_pay.b500,
          b100: this.sale_pay.b100,
          b50: this.sale_pay.b50,
          b20: this.sale_pay.b20,
          c10: this.sale_pay.c10,
          c5: this.sale_pay.c5,
          c2: this.sale_pay.c2,
          c1: this.sale_pay.c1,
          c050: 0,
          c025: 0
        },
        pay_change: {
          b1000: 0,
          b500: 0,
          b100: 0,
          b50: 0,
          b20: 0,
          c10: 0,
          c5: 0,
          c2: 0,
          c1: 0,
          c050: 0,
          c025: 0
        },
        items: this.$store.state.sale_subs
      }
      console.log(JSON.stringify(this.payload))
      this.$store.state.isLoading = true
      api.closeSaleV2(
        this.payload,
        header,
        result => {
          if (result.response == 'success') {
            // this.$socket.sendObj({
            //   command: 'receive_close'
            // })
            if (this.$store.state.SaleID == 5) {
              const obj = {
                ref_number: this.$store.state.ref_number,
                status: 'PROCESSING'
              }
              api.getReceiveC9(
                obj,
                header,
                result => {
                  console.log(result)
                  let text = ''
                  let title = ''
                  switch (this.lang) {
                    case 0:
                      text = 'Already refunded to your wallet.'
                      title = 'Process'
                      break
                    case 2:
                      text = '已退還到您的錢包'
                      title = '處理'
                      break
                    default:
                      text =
                        'คืนเงินเข้ากระเป๋าเงินของท่านเรียบร้อยแล้ว'
                      title = 'ประมวลผล'
                      break
                  }
                  swal(title, text, 'success')
                  this.$router.push({
                    name: 'Main'
                  })
                },
                error => {
                  alert(JSON.stringify(error))
                }
              )
            } else {
              console.log(this.$store.state.acl)
              if (this.$store.state.acl === 1) {
                this.$socket.sendObj({
                  command: 'open_cash_box',
                  data: 10
                })
              }
              let text = ''
              let title = ''
              switch (this.lang) {
                case 0:
                  text = 'Already refunded to your wallet.'
                  title = 'Process'
                  break
                case 2:
                  text = '已退還到您的錢包'
                  title = '處理'
                  break
                default:
                  text =
                    'คืนเงินเข้ากระเป๋าเงินของท่านเรียบร้อยแล้ว'
                  title = 'ประมวลผล'
                  break
              }
              swal(title, text, 'success')
              this.$router.push({
                name: 'Main'
              })
            }
          } else {
            alert(JSON.stringify(result))
          }
          this.$store.state.isLoading = false
        },
        error => {
          console.log(JSON.stringify(error))
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    checkValid() {
      this.Soundclick()
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }
      if (!this.IDWallet) {
        this.$store.state.IDWallet = ''
        this.walletChangeID.forEach(val => {
          if (val['data'] != '-') {
            this.$store.state.IDWallet += val['data']
          }
        })
      }
      var numberPhone = this.IDWallet.substring(1, this.IDWallet.length)
      var body = {
        // _compgrp: "commons",
        // _comp: "api",
        // _action: "validate",
        // vending_id: this.$store.state.UUID,
        code: '+66' + numberPhone
      }
      api.checkValidate(
        body,
        header,
        result => {
          if (result.response == 'invalid') {
            let text = ''
            let title = ''
            let text2 = ''
            let title2 = ''
            switch (this.lang) {
              case 0:
                text = 'This number has not been confirmed by the owner. Do you want to register?'
                title = 'Notification'
                text2 = 'Successful member registration Please contact the staff to confirm ownership'
                title2 = 'Notification'
                break
              case 2:
                text = '該號碼尚未得到業主的確認。你想註冊嗎？'
                title = '來自系統的通知'
                text2 =
                  '會員註冊成功請聯繫工作人員確認所有權。'
                title2 = '來自系統的通知'
                break
              default:
                text =
                  'หมายเลขนี้ยังไม่ได้ยืนยันเจ้าของ ท่านต้องการลงทะเบียนหรือไม่ ?'
                title = 'แจ้งเตือนจากระบบ'
                text2 =
                  'การลงทะเบียนรหัสสมาชิกสำเร็จ กรุณาติดต่อเจ้าหน้าที่เพื่อยืนยันความเป็นเจ้าของ'
                title2 = 'แจ้งเตือนจากระบบ'
                break
            }
            swal.fire({
              title: title,
              text: text,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes!'
            }).then((result) => {
              if (result.value) {
                this.refund()
                swal.fire(
                  title2,
                  text2,
                  'success'
                )
              } else {
                $('#walletid').modal('show')
              }
            })
          } else {
            this.$store.state.sale_subs = []
            this.SaleID = 1
            this.refund()
          }
        },
        error => {
          console.log(JSON.stringify(error))
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    Payment() {
      this.$store.state.isLoading = true
      this.Soundclick()
      $('#walletid').modal('hide')
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }
      if (this.SaleID == 1) {
        var mode = 'Deposit'
        var payment_type_text = 'cash'
        var type_text = 'Wallet'
        switch (this.lang) {
          case 0:
            payment_type_text = 'cash'
            type_text = 'Wallet'
            mode = 'Deposit'
            break
          case 1:
            payment_type_text = 'เงินสด'
            type_text = 'เติมเงิน Wallet'
            mode = 'เติมเงิน'
            break
          case 2:
            payment_type_text = '現金'
            type_text = 'Wallet'
            mode = '存款'
            break
        }
        this.$store.state.sale_subs = [{
          line: 1,
          item_id: '0',
          item_name: payment_type_text,
          qty: 1,
          price_id: 1,
          price_name: type_text,
          price: parseFloat(this.AmountPayment),
          unit: ''
        }]
      }

      if (!this.IDWallet) {
        this.$store.state.IDWallet = ''
        this.walletChangeID.forEach(val => {
          if (val['data'] != '-') {
            this.$store.state.IDWallet += val['data']
          }
        })
      }
      var saletype = ''
      switch (this.SaleID) {
        case 1:
          saletype = 'deposit_cash'
          break
        case 2:
          saletype = 'sale_cash'
          break
        case 3:
          saletype = ''
          break
        case 4:
          saletype = 'sale_cash'
          break
        case 5:
          saletype = 'sale_cash'
          break
        default:
          saletype = 'deposit'
          break
      }
      if (this.$store.state.SaleID !== 5) {
        this.$store.state.ref_number = this.txn_id
        this.status_partner = false
      } else {
        this.status_partner = true
      }
      if (this.IDWallet.length > 0) {
        var numberPhone = this.IDWallet.substring(1, this.IDWallet.length)
        var phone = '+66' + numberPhone
      } else {
        var phone = ''
      }
      this.payload = {
        shift_uuid: this.$store.state.shift_uuid,
        ref_number: this.$store.state.ref_number,
        txn_id: this.txn_id,
        type: saletype,
        partner: this.status_partner,
        member_phone: phone,
        amount: parseFloat(this.$store.state.total),
        payment_received: parseFloat(this.AmountPayment),
        payment_change: parseFloat(this.$store.state.total) - parseFloat(this.AmountPayment),
        flag_cash: this.flag_cash,
        payment: {
          currency: 'THB',
          b1000: this.sale_pay.b1000,
          b500: this.sale_pay.b500,
          b100: this.sale_pay.b100,
          b50: this.sale_pay.b50,
          b20: this.sale_pay.b20,
          c10: this.sale_pay.c10,
          c5: this.sale_pay.c5,
          c2: this.sale_pay.c2,
          c1: this.sale_pay.c1,
          c050: 0,
          c025: 0
        },
        pay_change: {
          b1000: 0,
          b500: 0,
          b100: 0,
          b50: 0,
          b20: 0,
          c10: 0,
          c5: 0,
          c2: 0,
          c1: 0,
          c050: 0,
          c025: 0
        },
        items: this.$store.state.sale_subs
      }
      console.log(JSON.stringify(this.payload))
      console.log(JSON.stringify(this.$store.state.sale_subs_slip))
      if (this.AmountPayment >= this.$store.state.total) {
        this.$store.state.isLoading = true
        api.closeSaleV2(
          this.payload,
          header,
          result => {
            console.log(JSON.stringify(result))
            if (result.response == 'success') {
              this.$socket.sendObj({
                command: 'receive_close'
              })
              if(this.SaleID == 1){

              } else if (this.$store.state.IDWallet == this.$store.state.config.client.telephone) {
              // if (this.$store.state.IDWallet == "0613351889") {
                var data_slip = {
                  "command": "print_slip",
                  "data": {
                    "client_tax_id": "",
                    "shop_title": this.$store.state.config.client.shop_title,
                    "shop_website": this.$store.state.config.client.shop_website,
                    "logo_image_width": 300,
                    "total": parseFloat(this.$store.state.total),
                    "payment": parseFloat(this.AmountPayment),
                    "change": (parseFloat(this.$store.state.total)-parseFloat(this.AmountPayment))*(-1),
                    "type": "take_home",
                    "unchange": (parseFloat(this.$store.state.total)-parseFloat(this.AmountPayment))*(-1),
                    "status": 0,
                    "queue_no": result.queue,
                    "sale_pay": {
                      "B1000": this.sale_pay.b1000,
                      "B500": this.sale_pay.b500,
                      "B100": this.sale_pay.b100,
                      "B50": this.sale_pay.b50,
                      "B20": this.sale_pay.b20,
                      "C10": this.sale_pay.c10,
                      "C5": this.sale_pay.c5,
                      "C2": this.sale_pay.c2,
                      "C1": this.sale_pay.c1,
                    },
                    "sale_subs": this.$store.state.sale_subs_slip
                  }
                }
                // var data_slip = {
                //   "command": "print_unpaid_change",
                //   "data": {
                //     "queue_number": result.queue,
                //     "shop_title": this.$store.state.config.client.shop_title,
                //     "vending_id": 102,
                //     "unpaid_change": (parseFloat(this.$store.state.total)-parseFloat(this.AmountPayment))*(-1),
                //     "mode": 0
                //   }
                // }
                console.info(JSON.stringify(data_slip))
                this.$socket.sendObj(data_slip)
              } else {
                var data_slip = {
                  "command": "print_slip",
                  "data": {
                    "client_tax_id": "",
                    "shop_title": this.$store.state.config.client.shop_title,
                    "shop_website": this.$store.state.config.client.shop_website,
                    "logo_image_width": 300,
                    "total": parseFloat(this.$store.state.total),
                    "payment": parseFloat(this.AmountPayment),
                    "change": (parseFloat(this.$store.state.total)-parseFloat(this.AmountPayment))*(-1),
                    "type": "take_home",
                    "unchange": 0,
                    "status": 0,
                    "queue_no": result.queue,
                    "sale_pay": {
                      "B1000": this.sale_pay.b1000,
                      "B500": this.sale_pay.b500,
                      "B100": this.sale_pay.b100,
                      "B50": this.sale_pay.b50,
                      "B20": this.sale_pay.b20,
                      "C10": this.sale_pay.c10,
                      "C5": this.sale_pay.c5,
                      "C2": this.sale_pay.c2,
                      "C1": this.sale_pay.c1,
                    },
                    "sale_subs": this.$store.state.sale_subs_slip
                  }
                }
                console.info(JSON.stringify(data_slip))
                this.$socket.sendObj(data_slip)
              }
              if (this.$store.state.SaleID == 5) {
                const obj = {
                  ref_number: this.$store.state.ref_number,
                  status: 'PROCESSING'
                }
                api.getReceiveC9(
                  obj,
                  header,
                  result => {
                    console.log(result)
                    this.$store.state.history_page = 'Cash'
                    this.$router.push({
                      name: 'ProcessCash'
                    })
                  },
                  error => {
                    alert(JSON.stringify(error))
                  }
                )
              } else {
                console.log(this.$store.state.acl)
                if (this.$store.state.acl === 1) {
                  this.$socket.sendObj({
                    command: 'open_cash_box',
                    data: 10
                  })
                }
                this.$store.state.history_page = 'Cash'
                this.$router.push({
                  name: 'ProcessCash'
                })
              }
            } else {
              alert(JSON.stringify(result))
            }
            this.$store.state.isLoading = false
          },
          error => {
            console.log(JSON.stringify(error))
            this.$store.state.isLoading = false
            alert(JSON.stringify(error))
          }
        )
      }
    },
    delayloading() {
      this.isLoadingcash = true
      setInterval(
        function () {
          this.isLoadingcash = false
        }.bind(this),
        2000
      )
    },
    openModal() {
      this.$store.state.isLoading = true
      if (this.AmountPayment == 0) {

        return
      }
      else if (this.AmountPayment >= this.$store.state.total) {
        if (this.IDWallet) {
          this.ChangeID = this.IDWallet
          this.Payment()
        } else {
          if (this.SaleID === 5) {
            swal
              .fire({
                title: 'แจ้งเตือนจากระบบ?',
                text: 'ท่านต้องการรับใบเสร็จออนไลน์หรือไม่ ?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
              })
              .then(result => {
                if (result.value) {
                  $('#walletid').modal('show')
                  this.$socket.sendObj({
                    command: 'receive_close'
                  })
                } else {
                  this.Payment()
                }
              })
          } else {
            if (this.AmountPayment > this.$store.state.total) {
              $('#walletid').modal('show')
              this.$socket.sendObj({
                command: 'receive_close'
              })
            } else {
              swal
                .fire({
                  title: 'แจ้งเตือนจากระบบ?',
                  text: 'ท่านต้องการรับใบเสร็จออนไลน์หรือไม่ ?',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No'
                })
                .then(result => {
                  if (result.value) {
                    $('#walletid').modal('show')
                    this.$socket.sendObj({
                      command: 'receive_close'
                    })
                  } else {
                    this.Payment()
                  }
                })
            }
          }
        }
        this.$store.state.isLoading = false
      } else {
        if (this.SaleID == 1) {
          if (this.AmountPayment > 0) {
            this.Payment()
          }
        }
        this.$store.state.isLoading = false
      }
    },
    checkMobile() {
      console.log(this.numberID.length)
      if (this.numberID.length > 11) {
        if (this.walletChangeID[0]['data'] === '0') {
          this.Payment()
        } else {
          let text = ''
          let title = ''
          switch (this.lang) {
            case 0:
              text = 'Please enter the ID Wallet you want to fill.'
              title = 'Warning'
              break
            case 2:
              text = '請輸入您要填寫的代碼。'
              title = '通知'
              break
            default:
              text =
                'กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์ ลงในช่องว่าง ให้ถูกต้อง'
              title = 'แจ้งเตือน'
              break
          }
          swal(title, text, 'warning')
        }
      } else {
        let text = ''
          let title = ''
          switch (this.lang) {
            case 0:
              text = 'Please enter the ID Wallet you want to fill.'
              title = 'Warning'
              break
            case 2:
              text = '請輸入您要填寫的代碼。'
              title = '通知'
              break
            default:
              text =
                'กรุณากรอกเบอร์โทรศัพท์ ลงในช่องว่างให้ถูกต้อง'
              title = 'แจ้งเตือน'
              break
          }
          swal(title, text, 'warning')
      }
    },
    addAmount(int) {
      this.Soundclick();
      if (this.numberID.length < 12) {
        this.numberID += int.toString()
        this.walletChangeID[this.numberID.length - 1]['data'] = int
        if (this.numberID.length == 3 || this.numberID.length == 7) {
          this.numberID += '-'
          this.walletChangeID[this.numberID.length - 1]['data'] = '-'
        }
      }
    },
    del() {
      if (this.numberID.length > 0) {
        if (this.numberID.length == 4 || this.numberID.length == 8) {
          this.numberID = this.numberID.substring(0, this.numberID.length - 2)
          this.walletChangeID[this.numberID.length]['data'] = ''
        } else {
          this.numberID = this.numberID.substring(0, this.numberID.length - 1)
          this.walletChangeID[this.numberID.length]['data'] = ''
        }
      }
    },
    addmonnyTest(val) {
        AmountPayment += parseInt(val)
    },
    submitter() {
      this.Soundclick()
      if (this.AmountPayment == 0) {
        return
      }
      else if (this.AmountPayment >= this.$store.state.total) {
        $('#condition').modal('show')
      }else{
        this.openModal()
      }
    },
    switchPayment (val) {
      if (val == 1) {
        $('#condition').modal('hide')
        this.flag_cash = 1
        // this.$store.state.IDWallet = '0613351889'
        this.$store.state.IDWallet = this.$store.state.config.client.telephone
        this.Payment()
      }
      if (val == 2) {
        $('#condition').modal('hide')
        this.openModal()
      }
    }
  },
  mounted() {
    console.log(this.submitted)
    this.delayloading()
    this.websocket_onmessage()
    this.$store.state.AmountPayment = 0
    this.ReceiveMoney()
    this.openSale()
    console.log("this.$store.state.total :", this.$store.state.total)
    clearInterval(this.$store.state.setInter)
    if (this.SaleID < 1 || !this.SaleID) {
      this.$router.push({
        name: 'Main'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/cash.js